// extracted by mini-css-extract-plugin
module.exports = {"info":"articles-module--info--1YIh2","title":"articles-module--title--1ossL","cardimg":"articles-module--cardimg--1wmrE","info_container":"articles-module--info_container--10UMs"};